import { Props_SnippetContent } from './Content.props'
import { CompileMarkdown} from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'

const SnippetContent = (props: Props_SnippetContent) => {
    const { heading, subheading, repeatable_link, paragraph, linkProps } = props
    
    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-content__heading--${heading.visibility.value}` : ''
    const linkAlignmentClass: string = linkProps.alignment?.value ? `snippet-content__link-container--${linkProps.alignment.value}` : ''

    return (
        <section className="snippet-content">
            <div className="snippet-content__container">
                <div className="snippet-content__container-heading">
                    {subheading?.content?.value && <p className='snippet-content__heading-sub'>{subheading?.content?.value}</p>}
                    <h2 className={`snippet-content__heading ${classHeadingVisibility}`}>{heading?.content?.value}</h2>
                </div>
                <div className="snippet-content__content">
                    {paragraph?.text?.value && CompileMarkdown(paragraph.text.value)}
                </div>
                   <div className={`snippet-content__link-container ${linkAlignmentClass}`}>
                       {repeatable_link.map((link, index) => (
                            <SnippetLink
                                key={`link-${link?.linkHref?.value} ${index}`}
                                linkStyles={link?.linkStyle?.value}
                                className="snippet-content__link"
                                url={link?.linkHref?.value}
                                target={link?.linkTarget?.value}
                            >
                                {link?.linkContent?.value}
                            </SnippetLink>
                       ))}
                   </div>
               
            </div>
        </section>
    )}

export default SnippetContent
